import { addMethod, string, object, boolean } from 'yup';

const phoneValidation = value => {
  if (!value) {
    return false;
  }

  return value.length >= 5 && value.length <= 18;
};

const linkedInUrlValidation = value => {
  if (!value) return true;

  const prefix = 'https://www.linkedin.com/in/';
  const userId = value.substring(prefix.length);

  return value.startsWith(prefix) && userId.length >= 3;
};

addMethod(string, 'checkLinkedInUrl', function (message) {
  return this.test('checkLinkedInUrl', message, function (value) {
    return linkedInUrlValidation(value);
  });
});

addMethod(string, 'checkPhone', function (message) {
  return this.test('checkPhone', message, function (value) {
    return phoneValidation(value);
  });
});

const corporateEmail = messages => {
  return string()
    .email(messages.required)
    .matches(/^[a-zA-Z0-9_-]{1,64}[.@a-zA-Z0-9-]{1,63}?\.[a-z]{2,6}$/, {
      message: messages.required,
    })
    .required(messages.required);
};

const phone = messages => {
  const message = 'Please, enter your phone number';

  return string()
    .required(messages || message)
    .checkPhone(messages || message);
};

export const corporateFormSchema = (messages, values) => {
  return object().shape(
    {
      name: string().required(messages.name),
      email: corporateEmail(messages.email),
      phone: phone(messages.phone),
      message: string().required(messages.message),
      linkedIn: string().min(2).checkLinkedInUrl(messages.linkedIn),
      NDA: boolean(),
    },
    ['email', 'phone'],
  );
};
